import common from './common';

export default {
  ...common,
  firebaseConfig: {
    apiKey: 'AIzaSyCSOXAGl_BhhstLj-vgU-uN0HQEG0sN9t0',
    authDomain: 'dss-maw-nonpci-prod-940326.firebaseapp.com',
    projectId: 'dss-maw-nonpci-prod-940326',
    storageBucket: 'dss-maw-nonpci-prod-940326.firebasestorage.app',
    messagingSenderId: '276903250388',
    appId: '1:276903250388:web:f6c6834a4e707c87ec6e41',
    measurementId: 'G-729P73NGD0',
  },
};
